"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INIT = "tochispot/INIT";
exports.ADD_SPOT = "tochispot/ADD_SPOT";
exports.PAN_TO = "tochispot/PAN_TO";
exports.FILTER = "tochispot/FILTER";
exports.RESET = "tochispot/RESET";
